import axios from '../utils/axios.js'
import { CLIENT_API } from './const.js'

const userApi = {
    login: (data) => axios({
        url: `${CLIENT_API}/webapi/userLogin/webAuth`,
        method: 'post',
        data
    }),
    logout: (data) => axios({
        url: `${CLIENT_API}/webapi/userLogin/logout`,
        method: 'post'
    }),
    info: (data) => axios({
        url: `${CLIENT_API}/webapi/user/info/brief`,
        method: 'get'
    }),
    update: (data) => axios({
        url: `${CLIENT_API}/webapi/user/info/update`,
        method: 'post',
        data
    }),
    sendVerificationCode: () => axios({
        url: `${CLIENT_API}/webapi/user/sendVerificationCode`,
        method: 'post',
    }),
    verifyEmail: (verificationCode) => axios({
        url: `${CLIENT_API}/webapi/user/verificationCode`,
        method: 'post',
        data: { verificationCode }
    }),
    pnlCurve: (data) => axios({
        url: `${CLIENT_API}/webapi/user/balance/curve`,
        method: 'post',
        data
    }),
    availableBalance: () => axios({
        url: `${CLIENT_API}/webapi/user/balance/available/balance`,
        method: 'get',
    }),
}

export default userApi